import { render, staticRenderFns } from "./OfferDontGetScammed.vue?vue&type=template&id=880b7aca&"
import script from "./OfferDontGetScammed.vue?vue&type=script&lang=js&"
export * from "./OfferDontGetScammed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports